import type { ReactElement } from 'react'

export default function Product({ product }: ProductThemeComponentProps): ReactElement {
  return (
    <div className="template-product">
      <div>{product.name}</div>
    </div>
  )
}
